import React, { Component } from 'react';


class PercentField extends Component {

    render() {
        const {fieldName, fieldLabel, fieldValue, fieldOnChange, disabled=false, optional=false, optionalText="optional", errors} = this.props

        return (
            <div className="data-panel__form__field" id={`div_id_${fieldName}`} aria-label={fieldLabel}>
                <label htmlFor={`id_${fieldName}`} className="data-panel__form__field__label in-form">{fieldLabel}{optional && <span className="text-optional"> ({optionalText})</span>}</label>
                <div className="data-panel__form__field__input">
                    <div className="data-panel__form__field__input-group" title={disabled && fieldValue ? `${fieldValue}%` : null}>
                        <input
                            defaultValue={parseFloat(fieldValue)}
                            onChange={event => fieldOnChange(event.target.value)}
                            type="number"
                            min="0"
                            max="100"
                            step="0.25"
                            id={`id_${fieldName}`}
                            name={fieldName}
                            autoComplete="off"
                            className={disabled ? "is-disabled" : ""}
                            disabled={disabled}
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">%</div>
                        </div>
                    </div>
                </div>
                {errors[fieldName] && <div className="data-panel__form__field__errors" aria-label="Field Errors">{errors[fieldName]}</div>}
            </div>
        )
    }
}

export default PercentField;
